import React, { useContext, useEffect, useState } from 'react'
import { Grid, Box, Divider, IconButton, styled } from '@mui/material'
import { DeleteForever } from '@mui/icons-material'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import DefaultPainel from '../../components/shared/Painel'
import BaseFilter from '../../components/BaseFilter'
import FormSugestao from '../../components/forms/Sugestao'
import TableHeader from '../../components/shared/tables/TableHeader'
import gerarPaginacao from '../../services/pagination'
import SugestoesObras from '../../services/http/leitores/SugestoesObras'
import { confirmDelete } from '../livros/functions'
import SmallTextField from '../../components/textfield/SmallTextfield'
import { PermissionsContext } from '../../providers/permissions'
import getUser from '../../services/http/user/getUser'
import PrivateRC from '../../components/PrivateRC'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import filter from './filters'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const SuggestionTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal'
  }
}))

const sugestao = () => {
  const [sugestoes, setSugestoes] = useState([])
  const [queryLector, setQueryLector] = useState([])
  const [query, setQuery] = useState({})
  const { hasThisPermission, permissions } = useContext(PermissionsContext)

  useEffect(() => {
    init()
  }, [])

  const init = () => {
    getSugestoes()
  }

  const [currentPage, setCurrentPage] = useState(0)
  const [lastPage, setLastPage] = useState(0)
  const [tloading, setTloading] = useState(false)

  const getSugestoes = async (filters = {}, page = 1) => {
    const user = await getUser()
    let userFilter = {}
    if (permissions?.roles?.length < 2) {
      userFilter = { 'includes[user][id]': user.id }
    }
    setTloading(true)
    const { data } = await SugestoesObras().show({
      page,
      ...filters,
      ...userFilter,
      'includes[]': 'user.leitor.biblioteca'
    })

    setLastPage(data.current_page)
    setCurrentPage(data.last_page)
    const aux = data.data.map(item => ({
      ...item,
      leitor: item.user.name,
      biblioteca: item.user.leitor.biblioteca.apelido
    }))
    setSugestoes(aux)
    setTloading(false)
  }

  let typingTimer = ''

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[user][name]': `%${queryLector?.toUpperCase()}%`
      })
    )
    getSugestoes(query)
  }

  const handleClean = () => {
    if (queryLector !== '') {
      setQueryLector('')
      Object.assign(queryLector, '')
      delete query.titulo
      Object.assign(query)
      getSugestoes({ ...query, 'includes[user][name]': undefined })
    }
  }

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Empresa',
      flex: 1
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 3
    },
    {
      field: 'nome_obra',
      headerName: 'Livro',
      flex: 3
    },
    {
      field: 'autor',
      headerName: 'Autor',
      flex: 3
    },
    {
      field: 'ano',
      headerName: 'Ano',
      flex: 1
    },
    hasThisPermission({ permission: 'sugestoes-obras#delete' })
      ? {
          field: 'actions',
          headerName: 'Ações',
          align: 'center',
          flex: 1,
          renderCell: ({ row }) => {
            return (
              <IconButton
                onClick={() => {
                  const msg = `Deseja deletar esta sugestão?`
                  confirmDelete(row.id, 'sugestão', msg, deleteSugestao)
                }}
                color="error"
              >
                <DeleteForever />
              </IconButton>
            )
          }
        }
      : {}
  ].map(item => {
    return { ...item, headerClassName: 'styledHeader', sortable: false }
  })
  const deleteSugestao = async id => {
    await SugestoesObras(id).delete(
      {},
      { notification: true, message: 'Sucesso ao remover sugestão' }
    )
    getSugestoes({}, currentPage)
  }
  const pagination = gerarPaginacao(
    true,
    currentPage,
    lastPage,
    (event, value) => {
      getSugestoes(query, value)
    }
  )

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh', p: 2 }}>
        <FormSugestao
          onSubmitEnd={() => {
            getSugestoes(query, currentPage)
          }}
        />
      </DefaultPainel>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Lista de Sugestões"
              controls={
                <MobileFilterHeaderContainer>
                  <PrivateRC roles="bibliotecario">
                    <SmallTextField
                      type="text"
                      placeholder="Leitor"
                      color="white"
                      variant="standard"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLector(target.value)
                      }}
                      value={queryLector}
                      InputProps={{
                        style: { color: 'white' },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment action={handleClean} />
                        )
                      }}
                    />
                  </PrivateRC>

                  <BaseFilter
                    filter={filter}
                    color="white"
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      getSugestoes(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <SuggestionTable
                rows={sugestoes}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default sugestao
